import type { CreateElementOptions, Element, ParallaxElementConfig } from 'parallax-controller'

export function useParallaxController(props: ParallaxElementConfig) {
  const { $parallax } = useNuxtApp()

  $parallax.init()

  const parallaxRef = ref<any>(null)
  const element = ref<Element>()
  const controller = $parallax.getController()

  let createdElement: Element | undefined

  onMounted(() => {
    if (parallaxRef.value instanceof HTMLElement) {
      const options: CreateElementOptions = {
        el: parallaxRef.value,
        props,
      }
      createdElement = controller?.createElement(options)
      element.value = createdElement
    }
    else {
      throw new TypeError(
        'You must assign the ref returned by the useParallax() composable to an HTML Element.'
      )
    }
  })

  onUnmounted(() => {
    if (createdElement) {
      controller?.removeElementById(createdElement.id)
    }
  })

  watchEffect(() => {
    if (element.value) {
      if (props.disabled) {
        controller?.resetElementStyles(element.value)
        controller?.updateElementPropsById(element.value.id, props)
      }
      else {
        controller?.updateElementPropsById(element.value.id, props)
      }
    }
  })

  return { parallaxRef, controller, element }
}
